<div [hidden]="!_message" [style.animation]="_bounceAnimation" class="error-pop" style="border:1px dashed var(--color-border-primary); padding:10px; border-radius: 5px; background-color: var(--color-messagebox-primary);">
    {{_message}}
</div>